<osn-cxb-dialog [title]="data?.title" [closeable]="false">
  <osn-cxb-page-selector
    [formControl]="targetPageControl"
    [errorLabel]="targetPageControl.touched && targetPageControl.hasError('required') ? 'Please select a page.' : undefined"
    [includeGenrePages]="isGenrePage"
    [includeContentPages]="!isGenrePage"
    [currentPageId]="data?.pageId"
    [placeholder]="'Target page'"
    [excludeDrafts]="false"
  ></osn-cxb-page-selector>
  <div class="actions">
    <button class="secondary cxb-button" (click)="closeDialog()">{{ data?.cancelBtnLabel }}</button>
    <button class="confirm-btn cxb-button" (click)="cloneTray()" [disabled]="targetPageControl.invalid">
      {{ data?.confirmBtnLabel }}
    </button>
  </div>
</osn-cxb-dialog>
